import uniqBy from "lodash/uniqBy";

import {IntermediatePart} from "../../parts/intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {Shower} from "../../parts/shower";

export default class GrabBar extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'grab_bar';
    this.partName = 'Grab Bar';
    this.translateId = "visualizer.bathroom.accessories.grab_bar";
    this.visible = true;
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new GrabBar());
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return uniqBy(featuresToDisplay, (feature) => feature.dbFeature.id)
      .map(_ => new DesignNavigationItem(_.featureName, _));
  }

  // setLayers(layout) {
  //
  //   const conditions = this.getArrayOfConditions();
  //   if ((this.activeFeature && this.activeFeature.matchesMetaForArrayOfConditions(conditions)
  //     || (this.activeFeature && this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
  //     return super.setLayers(layout);
  //   }
  //
  //   this.setDefault();
  //   return super.setLayers(layout);
  // }

  getArrayOfConditions() {
    const accParent = this.getParent();
    const showerParent = accParent.layout.parts[Shower.id];
    const activeShowerPartId = showerParent && showerParent.showerTubComboIsActive() ? ShowerTubCombo.id : Shower.id;
    const showerSize = showerParent.layout.parts[activeShowerPartId].showerSize();
    return [{
      propName: 'ShowerSize',
      propValue: showerSize
    }]
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.Custom60in.GrabBar;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }

}
